/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 11.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import _groupBy from 'lodash/groupBy';
import _forOwn from 'lodash/forOwn';

import Translate from '../../../../Translate';

class Persons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: _groupBy(props.persons, 'role')
    }
  }

  componentWillReceiveProps(newProps) {

    this.setState({roles: _groupBy(newProps.persons, 'role')});
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  
  _renderRoles() {
    let map = [];

    _forOwn(this.state.roles, function (persons, role) {

      map.push(<div key={role}>
        <div className="profile-normal-text color-grey"><Translate content={'profile.persons.' + role} /></div>
        {persons.map((person) => {
          return person.second_name + ' ' + person.first_name;
        }).join(',')}
      </div>);
    });

    return map;
  }

  render() {

    return (
      <div>{this._renderRoles()}</div>
    );
  }
}

Persons.propTypes = {
  persons: PropTypes.array
};

Persons.defaultProps = {
  persons: []
};

export default Persons;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Persons/persons.js